import React, { CSSProperties, useEffect, useMemo, useState } from "react";
import { usePopper } from "react-popper";

interface GhgsEmissQntPopperProps {
  percent1: number;
  percent2: number;
  percent3: number;
}

export default function GhgsEmissQntPopper({ percent1, percent2, percent3 }: Readonly<GhgsEmissQntPopperProps>) {
  const [referenceElement1, setReferenceElement1] = useState<any>(null);
  const [popperElement1, setPopperElement1] = useState<any>(null);
  const [arrowElement1, setArrowElement1] = useState<any>(null);

  const [referenceElement2, setReferenceElement2] = useState<any>(null);
  const [popperElement2, setPopperElement2] = useState<any>(null);
  const [arrowElement2, setArrowElement2] = useState<any>(null);

  const [referenceElement3, setReferenceElement3] = useState<any>(null);
  const [popperElement3, setPopperElement3] = useState<any>(null);
  const [arrowElement3, setArrowElement3] = useState<any>(null);

  const [boundary, setBoundary] = useState<any>(undefined);

  const arrowModifier1 = useMemo(() => ({
    name: 'arrow',
    options: {
      element: arrowElement1,
    },
  }), [arrowElement1]);
  const arrowModifier2 = useMemo(() => ({
    name: 'arrow',
    options: {
      element: arrowElement2,
    },
  }), [arrowElement2]);
  const arrowModifier3 = useMemo(() => ({
    name: 'arrow',
    options: {
      element: arrowElement3,
    },
  }), [arrowElement3]);
  const boundaryModifier = useMemo(() => ({
    name: 'preventOverflow',
    enabled: true,
    options: {
      mainAxis: true,
      boundary: boundary,
    }
  }), [boundary]);
  const offsetModifier = useMemo(() => ({
    name: 'offset',
    options: {
      offset: [0, 4],
    }
  }), []);

  const { styles: style1, attributes: attr1, forceUpdate: fu1 } = usePopper(referenceElement1, popperElement1, {
    strategy: 'fixed', placement: 'top',
    modifiers: [arrowModifier1, boundaryModifier, offsetModifier]
  });
  const { styles: style2, attributes: attr2, forceUpdate: fu2 } = usePopper(referenceElement2, popperElement2, {
    strategy: 'fixed', placement: 'bottom',
    modifiers: [arrowModifier2, boundaryModifier, offsetModifier]
  });
  const { styles: style3, attributes: attr3, forceUpdate: fu3 } = usePopper(referenceElement3, popperElement3, {
    strategy: 'fixed', placement: 'top',
    modifiers: [arrowModifier3, boundaryModifier, offsetModifier]
  });

  const tooltipWrapStyle: CSSProperties = {
    minWidth: '3.55rem',
    borderRadius: '0.3rem',
    border: '1px solid #D5DAE8',
    background: '#fff',
    boxShadow: '2px 2px 2px rgba(0, 0, 0, 0.25)',
    textAlign: 'center',
    padding: '0.1rem 0.1rem',
    justifyContent: 'center'
  };

  const tooltipTextStyle: CSSProperties = {
    fontSize: '0.8rem',
    fontWeight: '800',
  };

  const tooltipPercentStyle: CSSProperties = {
    fontSize: '0.6rem',
    fontWeight: '400',
    marginLeft: '0.15rem',
  };

  const borderStyle1 = percent2 == 0 && percent3 == 0 ? 'bdr-st1' : '';
  const borderStyle2 = percent1 == 0 && percent3 == 0 ? 'bdr-st1' : (percent1 == 0 ? 'bdr-st2' : (percent3 == 0 ? 'bdr-st3' : ''));
  const borderStyle3 = percent1 == 0 && percent2 == 0 ? 'bdr-st1' : '';

  useEffect(() => {
    if (fu1) {
      setTimeout(() => {
        fu1();
      }, 200)
    }
  }, [fu1]);

  useEffect(() => {
    if (fu2) {
      setTimeout(() => {
        fu2();
      }, 200)
    }
  }, [fu2]);

  useEffect(() => {
    if (fu3) {
      setTimeout(() => {
        fu3();
      }, 200)
    }
  }, [fu3]);

  return (
    <div ref={setBoundary} className="graph-count-vertical2 count-vertical">
      <div>
        <em data-count={`${percent1}%`}
            className={`finish c1 ${borderStyle1}`}
            style={{width: `${percent1}%`, position: 'relative'}}
            ref={setReferenceElement1}
        />
        <div ref={setPopperElement1} className="popper-tooltip help" style={{ ...style1.popper, ...tooltipWrapStyle }} {...attr1.popper}>
          <span style={{ ...tooltipTextStyle, color: '#545CC1' }}>
            {percent1}
            <em style={tooltipPercentStyle}>%</em>
          </span>
          <div ref={setArrowElement1} className="arrow" style={style1.arrow}></div>
        </div>

        <em data-count={`${percent2}%`}
            className={`finish c2 ${borderStyle2}`}
            style={{width: `${percent2}%`, position: 'relative'}}
            ref={setReferenceElement2}
        />
        <div ref={setPopperElement2} className="popper-tooltip help" style={{ ...style2.popper, ...tooltipWrapStyle }} {...attr2.popper}>
          <span style={{ ...tooltipTextStyle, color: '#4C96F9' }}>
            {percent2}
            <em style={tooltipPercentStyle}>%</em>
          </span>
          <div ref={setArrowElement2} className="arrow" style={style2.arrow}></div>
        </div>

        <em data-count={`${percent3}%`}
            className={`finish c3 ${borderStyle3}`}
            style={{width: `${percent3}%`, position: 'relative'}}
            ref={setReferenceElement3}
        />
        <div ref={setPopperElement3} className="popper-tooltip help" style={{ ...style3.popper, ...tooltipWrapStyle }} {...attr3.popper}>
          <span style={{ ...tooltipTextStyle, color: '#44C5DB' }}>
            {percent3}
            <em style={tooltipPercentStyle}>%</em>
          </span>
          <div ref={setArrowElement3} className="arrow" style={style3.arrow}></div>
        </div>
      </div>
    </div>
  );
}
